import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e087aeb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ml-1" }
const _hoisted_2 = { class: "ma-0 mt-2 gray__base__color hotel-search-dates" }
const _hoisted_3 = { class: "mt-0 primary__color hotel-search-range" }
const _hoisted_4 = { class: "room-picture__container" }
const _hoisted_5 = { class: "hotel-container" }
const _hoisted_6 = { class: "truncate black__base__color" }
const _hoisted_7 = { class: "hotel-container d-flex justify-space-between commodities-container" }
const _hoisted_8 = { class: "text-center room-type" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons icons-commodities gray__base__color" }, "hotel", -1))
const _hoisted_10 = { class: "ma-0 gray__base__color" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons icons-commodities gray__base__color" }, "child_care", -1))
const _hoisted_13 = { class: "ma-0 gray__base__color" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons icons-commodities gray__base__color" }, "group", -1))
const _hoisted_16 = { class: "ma-0 gray__base__color" }
const _hoisted_17 = { class: "hotel-price text-center my-1" }
const _hoisted_18 = { class: "gray__base__color pr-05" }
const _hoisted_19 = { class: "room__price primary__dark__color" }
const _hoisted_20 = { class: "room__price primary__dark__color" }
const _hoisted_21 = { class: "text-center mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_RegisterCard = _resolveComponent("RegisterCard")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_CoronaRoomFilter = _resolveComponent("CoronaRoomFilter")!

  return (_ctx.hotelDetails)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.filterBodyContainerClasses)
      }, [
        _createVNode(_component_el_row, {
          class: _normalizeClass(_ctx.filterOverflowHiddenClasses),
          justify: "end",
          gutter: 20
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 12,
              md: 14,
              lg: 16,
              xl: 18
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      xs: 24,
                      sm: 24,
                      md: 24,
                      lg: 24,
                      xl: 24,
                      class: "app__header__title"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("hotels.hotelBooking")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { class: "app__title" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.hotelDetails.name), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { class: "hotel-container" }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("hotels.availableSearch")), 1),
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.fromDate) + " - " + _toDisplayString(_ctx.toDate), 1)
                      ]),
                      _: 1
                    }),
                    (_ctx.unavailability)
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 0,
                          class: "hotel-container mb-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_card, { class: "text-center" }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", null, _toDisplayString(_ctx.$t("hotels.availableValidate")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roomsData, (room, id) => {
                      return (_openBlock(), _createBlock(_component_el_col, {
                        xs: 24,
                        sm: 24,
                        md: 12,
                        lg: 10,
                        xl: 10,
                        key: id
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_card, { class: "card-hotel ma-1" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_4, [
                                _createVNode(_component_el_carousel, {
                                  class: "room__carousel",
                                  "indicator-position": "none"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(room.pictures, (picture, index) => {
                                      return (_openBlock(), _createBlock(_component_el_carousel_item, { key: index }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_image, {
                                            src: picture,
                                            class: "room-picture__img"
                                          }, null, 8, ["src"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("h1", _hoisted_6, _toDisplayString(room.roomName), 1),
                                _createElementVNode("div", _hoisted_7, [
                                  _createElementVNode("div", _hoisted_8, [
                                    _hoisted_9,
                                    _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.filterRoomTypes(room.roomType)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_11, [
                                    _hoisted_12,
                                    _createElementVNode("p", _hoisted_13, _toDisplayString(room.roomCapacitychildren), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_14, [
                                    _hoisted_15,
                                    _createElementVNode("p", _hoisted_16, _toDisplayString(room.roomCapacityAdults), 1)
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("p", _hoisted_17, [
                                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("hotels.forOnly")), 1),
                                    _createElementVNode("span", _hoisted_19, "$" + _toDisplayString(room.price), 1),
                                    _createElementVNode("span", _hoisted_20, "/" + _toDisplayString(_ctx.$t("hotels.night")), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_21, [
                                _createVNode(_component_el_button, {
                                  class: "primary__dark__color__button",
                                  onClick: ($event: any) => (_ctx.checkRegisterWitoutTicket(room))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("hotels.book")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    _createVNode(_component_RegisterCard, {
                      onMethodToContinueRegister: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToReservation(false)))
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 12,
              md: 10,
              lg: 8,
              xl: 6,
              hotelDetails: _ctx.hotelDetails,
              class: _normalizeClass(_ctx.filerRoomFilterClasses)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CoronaRoomFilter, { hotelDetails: _ctx.hotelDetails }, null, 8, ["hotelDetails"])
              ]),
              _: 1
            }, 8, ["hotelDetails", "class"])
          ]),
          _: 1
        }, 8, ["class"])
      ], 2))
    : _createCommentVNode("", true)
}